import Promocode from "./Promocode";

export default Promocode;
